import type { Routes } from '@angular/router';

import { routesMetadata } from '@shared/models';

export const routes: Routes = [
	{
		path: routesMetadata.portal.relative,
		loadChildren: () => import('./portal/portal.routes').then((mod) => mod.PORTAL_ROUTES)
	},
	{
		path: routesMetadata.auth.relative,
		loadChildren: () => import('./_layout/auth/auth.routes').then((mod) => mod.AUTH_ROUTES)
	},
	{ path: '**', redirectTo: '' }
];
